// extracted by mini-css-extract-plugin
export default {"SidebarMobile":"SidebarMobile_SidebarMobile__JzOrp","visible":"SidebarMobile_visible__uvHFU","hidden":"SidebarMobile_hidden__-OSqa"};